export default "__VITE_ASSET__9893487e__"